import { Component, ViewChild, OnInit, OnDestroy, inject } from '@angular/core';
import { MaintenanceModeConfiguration } from './maintenance-mode-configuration';
import { AuthenticationService } from '../../../security/authentication.service';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { SelectionService } from '../../../services/selection/selection.service';
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { MaintenanceModeNotificationModalService } from './maintenance-mode-notification-modal.service';

@Component({
  selector: 'app-maintenance-mode-notification',
  templateUrl: './maintenance-mode-notification.component.html',
  styleUrls: ['./maintenance-mode-notification.component.scss'],
  standalone: false
})
export class MaintenanceModeNotificationComponent implements OnInit, OnDestroy {
  authService = inject(AuthenticationService);
  navigationService = inject(NavigationService);
  private selectionService = inject(SelectionService);


  configuration: MaintenanceModeConfiguration;    
  @ViewChild('modalRef') modalComponent: ModalComponent;    
  modalTitle: string;
  showOrgName = false;
  private readonly subscriptions: any[] = [];
  private readonly maintenanceModeNotificationModalService: MaintenanceModeNotificationModalService = inject(MaintenanceModeNotificationModalService);

  ngOnInit(): void {
   const sub = this.maintenanceModeNotificationModalService.modalState$.subscribe((data) => {
      if (!data) return;
      if (data?.config) {
        this.configuration = data?.config;
         if (this.configuration) {
          this.showOrgName = this.configuration?.State === 'returntotoplevel';
          this.modalTitle = this.getModalTitle();
        }        
      }
      if (data?.isOpen) {
        this.open();
      } else {
        this.close();
      }
    });
    this.subscriptions.push(sub);
  }

  ngOnDestroy(): void {
     for (const s of this.subscriptions) {
      s.unsubscribe();
    }
  }

  getModalTitle(): string {
    let title = 'Rightworks Maintenance Mode';
    const state = this.configuration?.State;
    if (state === 'returntotoplevel') {
      return title;
    }
    if (state === 'logoutonly') {
      title = `Rightworks services for ${this.configuration?.OrganizationName} are offline for maintenance`;
    }
    return title;
  }  

  async returnToSearch(): Promise<void> {
    this.close();
    await this.navigationService.GoHome();
  }

  removeFromMaintenanceMode(): void {
    this.close();
  }

  async goToTopLevelOrg(): Promise<void> {
    const topLevelOrgID = this.selectionService.getSelectedTopLevelOrg()?.ID;    
    await this.navigationService.OpenOrganization(topLevelOrgID);
    // Forcing reload as navigation doesn't select in tree correctly with soft navigation
    window.location.reload();
    this.close();
  }

  async logout(): Promise<void> {
    this.close();
    await this.navigationService.GoToLoginPage();
    await this.authService.logout();
  }

  open(): void {    
    this.modalComponent?.open();
  }

  close(): void {
    this.modalComponent?.close();
  }
}
